import RootState from 'model/State/RootState';

export const selectIsFeaturesGuideOpen = (state: RootState) =>
  state.featuresGuide.isOpen;
export const selectFeaturesGuideCurrentStep = (state: RootState) =>
  state.featuresGuide.currentStep;
